import React from 'react';
import ReactDOM from 'react-dom';
import './theme/light-theme.css';
import './theme/dark-theme.css';
import './index.css';
import App from './App';
import { GoogleOAuthProvider } from "@react-oauth/google";
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <GoogleOAuthProvider clientId="93558665157-s0oosl8ca1rf7ed69a18120a84sn11qu.apps.googleusercontent.com">
    <App />
  </GoogleOAuthProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
